import { createSlice } from "@reduxjs/toolkit";
import { fetchExternalIntegrationMappings, addExternalIntegrationMapping, updateExternalIntegrationMapping } from "./external-integration-mappings.thunk";
import { IExternalIntegrationMapping } from "@grudder/types/general.types";

interface ExternalIntegrationMappingsState {
    data: {
        total: number;
        data: IExternalIntegrationMapping[];
    };
    loading: boolean;
    error: any;
}

const initialState: ExternalIntegrationMappingsState = {
    data: {
        total: 0,
        data: [],
    },
    loading: false,
    error: null,
};

const externalIntegrationMappersSlice = createSlice({
    name: "externalIntegrationMappers",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchExternalIntegrationMappings.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchExternalIntegrationMappings.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
        });
        builder.addCase(fetchExternalIntegrationMappings.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
        builder.addCase(addExternalIntegrationMapping.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(addExternalIntegrationMapping.fulfilled, (state, action) => {
            state.loading = false;
            state.data.data.push(...action.payload);
        });
        builder.addCase(addExternalIntegrationMapping.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
        builder.addCase(updateExternalIntegrationMapping.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(updateExternalIntegrationMapping.fulfilled, (state, action) => {
            state.loading = false;
            state.data.data = state.data.data.map((item) => item._id === action.payload._id ? action.payload : item);
        });
        builder.addCase(updateExternalIntegrationMapping.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    },
});

export const { reducer: externalIntegrationMappersReducer } = externalIntegrationMappersSlice;